import React from "react";
import PersonalInformationSection from "./PersonalInformationSection";
import { useGetProfile } from "../../lib/queries/queriesAndMutations";
import ApiKeysPage from "../apikeys";
import Loader from "../../shared/Loader";
import IbanNote from "./IbanNote";
import TitleContainer from "../../shared/TitleContainer";
import icons from "../../lib/icons";
import ProfileSecuritySection from "./ProfileSecuritySection";

function Profile() {
  const { data: profile, isPending, isRefetching } = useGetProfile();

  if (isPending || isRefetching) {
    return (
      <div className="w-full h-full flex justify-center items-center min-h-[400px]">
        <Loader />
      </div>
    );
  }

  const twoFactorSettings = [
    {
      label: "فعالسازی پیامک",
      name: "sms_2fa",
      feildIsActive: profile?.sms_2fa,
    },
    {
      label: "فعالسازی ایمیل",
      name: "email_2fa",
      feildIsActive: profile?.email_2fa,
    },
    {
      label: "فعالسازی اپلیکیشن Google Authenticator",
      name: "google_2fa",
      feildIsActive: profile?.google_2fa,
    },
  ];

  return (
    <div className="flex flex-col gap-3">
      <div className="profile-wrapper">
        <TitleContainer title="اطلاعات هویتی" icon={icons.person} />
        <PersonalInformationSection data={profile} />
      </div>

      <div className="profile-wrapper">
        <TitleContainer title="امنیت کاربری" icon={icons.security} />
        <ProfileSecuritySection
          items={profile}
          twoFactorSettings={twoFactorSettings}
        />
      </div>

      <div className="profile-wrapper">
        <TitleContainer title="توسعه دهندگان" icon={icons.security} />
        <ApiKeysPage />
      </div>

      <div className="profile-wrapper">
        <TitleContainer title="حساب‌های بانکی" icon={icons.bank_card} />
        <IbanNote />
      </div>
    </div>
  );
}

export default Profile;
